<div class="mt-2">
	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<div *ngIf="items.length > 0">
		<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
			<thead>
				<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
					[displayOptions]="displayOptions">
				</tr>
			</thead>
			<tbody *ngIf="!loading && itemsToShow?.length > 0">
				<tr *ngFor="let item of itemsToShow; let i = index">
					<td class="text-nowrap">
						{{ item.not_before | date: ac.tableDateTimeFmt }}
					</td>
					<td class="text-nowrap">
						{{ item.sent_at | date: ac.tableDateTimeFmt }}
					</td>
					<td class="text-nowrap">
						{{ item['__status'] }}
					</td>
					<td class="text-nowrap">
						{{item['__type'] }}
					</td>
					<td *ngIf="showUserInfo" class="text-nowrap">
						<a [routerLink]="['/' + ac.urls.users, item.user_id]">
							{{ item.message_to }}
						</a>
					</td>
					<td [title]="item.message_subject">
						<fa-icon *ngIf="item.reply_to" [icon]="['fas', 'asterisk']" class="text-info"
							[ngbTooltip]="'Reply-To: ' + item.reply_to">
						</fa-icon>
						{{ tt.chopString(item.message_subject, 50) }}
					</td>
					<td class="text-center">{{ item.num_attachments }}</td>
				</tr>
			</tbody>
		</table>
		<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
			[centered]="false"></app-paging-bar>
	</div>

</div>